/*
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-18 14:09:28
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-26 15:07:37
 * @FilePath: /privacy-web/src/utils/indexDB/index.js
 */
import indexDb from './indexDbManager';
import api from '@/api/index.js';
import axios from 'axios';
// import data from 'public/resourceConfig.json'
// import data from 'public/resourceConfigCopy.json'
// let indexDbManager = new indexDb()
// let dbname = 'dictCache'
// let version = 1
// let newStore = {
//   name: 'dict',
//   key: 'id'
// }
// async function initData () {
//   let dbObject = await indexDbManager.initIndexDB(dbname, version, newStore)
//   let { data } = await api.getDictData()
//   indexDbManager.add(dbObject, 'dict', data)
//   return dbObject
// }
// // export default indexDbObject
// export default {
//   install (Vue) {
//     // 将indexDbManager的方法注册到vue的生命周期上。
//     Vue.prototype.initIndexDB = async function () {
//       let dbObject = await initData()
//       Vue.prototype.dbObject = dbObject
//     }
//     // 通过key,取所有数据字典项
//     Vue.prototype.readDictByKey = async (key) => {
//       // eslint-disable-next-line no-return-await
//       return await indexDbManager.readDataByKey('dict', key)
//     }
//   }
// }
const URL = process.env.VUE_APP_URL;
const indexDbObject = {
  install(Vue) {
    // 设置全局的bdObject
    // Vue.prototype.dbObject = null;
    // 创建indexDbManager对象
    // eslint-disable-next-line new-cap
    let indexDbManager = new indexDb();
    // eslint-disable-next-line one-var
    let dbname = 'dictCache',
      version = 1,
      newStore = {
        name: 'dict',
        key: 'id'
      };
    indexDbManager.initIndexDB(dbname, version, newStore).then(async dbObject => {
      Vue.prototype.dbObject = dbObject;
      // console.log('请求字典');
      const res = await api.getDefaultConfig();
      await indexDbManager.add(dbObject, 'dict', res);
      // if (Vue.prototype.setMethod) {
      //   Vue.prototype.setMethod()
      // }
      if (Vue.prototype.setArr && Vue.prototype.setArr.length > 0) {
        Vue.prototype.setArr.forEach((item, index) => {
          Vue.prototype[`${item}${index}`]();
        });
      }
      return new Promise((resolve) => {
        resolve(dbObject);
      });
      // axios.get(`${URL}resourceConfig.json?uuid=${Math.random()}`)
      //   .then(async (res) => {
      //     console.log('res', res.data);
      //     await indexDbManager.add(dbObject, 'dict', res.data);
      //     // if (Vue.prototype.setMethod) {
      //     //   Vue.prototype.setMethod()
      //     // }
      //     if (Vue.prototype.setArr && Vue.prototype.setArr.length > 0) {
      //       Vue.prototype.setArr.forEach((item, index) => {
      //         Vue.prototype[`${item}${index}`]();
      //       });
      //     }
      //     return new Promise((resolve, reject) => {
      //       resolve(dbObject);
      //     });
      //   }).catch((e) => {
      //     console.log('错误字典', e);
      //   });

      // indexDbManager.add(dbObject, 'dict', data)
      // if (Vue.prototype.setMethod) {
      //   Vue.prototype.setMethod()
      // }
      // return new Promise((resolve, reject) => {
      //   resolve(dbObject)
      // })
    });
    // 将indexDbManager的方法注册到vue的生命周期上。
    Vue.prototype.initIndexDB = async function (dbname, version, newStore) {
      let dbObject = await indexDbManager.initIndexDB(dbname, version, newStore);
      Vue.prototype.dbObject = dbObject;
      return new Promise((resolve, reject) => {
        resolve(dbObject);
      });
    };
    // 通过key,取所有数据字典项
    Vue.prototype.readDictByKey = async (key, fn) => {
      if (!Vue.prototype.dbObject) {
        // Vue.prototype.setMethod = async () => {
        //   let res = await indexDbManager.readDataByKey('dict', key)
        //   fn(res)
        // };
        if (!Vue.prototype.setArr) {
          Vue.prototype.setArr = [key];
          Vue.prototype[`${key}0`] = async () => {
            let res = await indexDbManager.readDataByKey('dict', key);
            fn(res);
          };
        } else {
          let arr = Vue.prototype.setArr;
          arr.push(key);
          Vue.prototype.setArr = arr;
          Vue.prototype[`${key}${Vue.prototype.setArr.length - 1}`] = async () => {
            let res = await indexDbManager.readDataByKey('dict', key);
            fn(res);
          };
        }
      } else {
        let res = await indexDbManager.readDataByKey('dict', key);
        fn(res);
      }
    };
  }
};
export default indexDbObject;
